import React, { Fragment } from 'react';
import { Card, CardBody} from 'reactstrap';
import FalconCardHeader from '../common/FalconCardHeader';
import DashboardResumen from './cienytech/DashboardResumen';

import loadable from '@loadable/component';

const LastPresupuestosTable = loadable(() => import('./cienytech/table.last.presupuestos'));
const LastAlbaranesTable = loadable(() => import('./cienytech/table.last.albaranes'));
const LastFacturasTable = loadable(() => import('./cienytech/table.last.facturas'));
const LastReservasTable = loadable(() => import('./cienytech/table.last.reservas'));

const Dashboard = () => {
  return (
    <Fragment>

      {/* Resumen de pendientes */}
      <DashboardResumen />

      {/* Últimos 10 presupuestos */}
      <Card className="mb-3">
        <FalconCardHeader title="Últimos presupuestos" light={false}/>
        <CardBody className="p-0">
          <LastPresupuestosTable />
        </CardBody>
      </Card>

      {/* Últimos 10 albaranes */}
      <Card className="mb-3">
        <FalconCardHeader title="Últimos albaranes" light={false}/>
        <CardBody className="p-0">
          <LastAlbaranesTable />
        </CardBody>
      </Card>

      {/* Últimas 10 facturas */}
      <Card className="mb-3">
        <FalconCardHeader title="Últimas facturas" light={false}/>
        <CardBody className="p-0">
          <LastFacturasTable />
        </CardBody>
      </Card>

      {/* Últimas 10 reservas */}
      <Card className="mb-3">
        <FalconCardHeader title="Últimas reservas" light={false}/>
        <CardBody className="p-0">
          <LastReservasTable />
        </CardBody>
      </Card>

    </Fragment>
  );
};

export default Dashboard;
